import Post from "../../../../src/components/post";
import B from "../../../../src/posts/blog/pactfi-aeneas-rewards-degen/button";
import * as React from 'react';
export default {
  Post,
  B,
  React
};